import getStore from '../store/store';
import { MailFolder } from 'owa-graph-schema';
import { ObservableMap } from 'mobx';

export default function getFolderTable(): ObservableMap<string, MailFolder> {
    return getStore().folderTable;
}
